import type React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingSpinner from "./LoadingSpinner";

interface ProtectedRouteProps {
	children: React.ReactNode;
	/** Allows admin OR stellar_admin */
	requireAdmin?: boolean;
	/** Only allows full admin (not stellar_admin) */
	requireFullAdmin?: boolean;
	walletId?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
	children,
	requireAdmin = false,
	requireFullAdmin = false,
	walletId,
}) => {
	const { isAuthenticated, isAdmin, hasAdminAccess, checkAccess, loading } =
		useAuth();

	if (loading) {
		return <LoadingSpinner size="lg" message="Loading..." centered />;
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	// requireFullAdmin: only full admin (user mgmt, settings, etc.)
	if (requireFullAdmin && !isAdmin) {
		return <Navigate to="/unauthorized" replace />;
	}

	// requireAdmin: admin or stellar_admin (dashboard access)
	if (requireAdmin && !hasAdminAccess) {
		return <Navigate to="/unauthorized" replace />;
	}

	if (walletId && !checkAccess(walletId)) {
		return <Navigate to="/unauthorized" replace />;
	}

	return <>{children}</>;
};

export default ProtectedRoute;
